module.exports = __webpack_public_path__ + "img/10.643894e9.png";